import React, { useEffect } from "react";
import Navbar from "../components/layout/navbar";
import Footer from "../components/layout/footer";
import Blogbanner from "../components/pages/Blogs/blogbanner";
import Blogcards from "../components/pages/Blogs/blogcards";

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Blogbanner />
      <Blogcards />
      <Footer />
    </>
  );
};

export default Blogs;
